import { SITE_DOMAIN } from '@/config/app.config'
import { magicLinkClient, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
    baseURL: SITE_DOMAIN,
    plugins: [magicLinkClient(), organizationClient()],
    session: {
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        refetchInterval: 60000, // 60 seconds
    },
})

export type AuthClientType = typeof authClient

export const { useSession, signIn, signOut, signUp, resetPassword, forgetPassword } = authClient
